import { AppBar, Box, Button, Container, IconButton, Link, Toolbar, Tooltip, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import LoginIcon from '@mui/icons-material/Login';
import { Link as RouterLink, Outlet } from 'react-router-dom';
import { useLanguage } from '@/i18n/LanguageContext';
import { LanguageSelector } from '@/components/common/LanguageSelector';

/** Mobile-first public shell: brand bar with language selector, narrow content column. */
export function PublicLayout() {
  const { ui } = useLanguage();
  const theme = useTheme();
  const compact = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Box minHeight="100dvh" display="flex" flexDirection="column" bgcolor="background.default">
      <AppBar position="static" elevation={0} sx={{ bgcolor: 'primary.main' }}>
        <Toolbar sx={{ maxWidth: 760, width: '100%', mx: 'auto', px: 2, minHeight: 60, gap: 2 }}>
          <Link component={RouterLink} to="/" underline="none" color="inherit" sx={{ flex: 1, lineHeight: 1.15 }}>
            <Typography fontWeight={700} fontSize="1.05rem" component="div">
              {ui('app.title')}
            </Typography>
            <Typography fontSize="0.78rem" sx={{ opacity: 0.9 }} component="div">
              {ui('app.subtitle')} · {ui('app.tagline')}
            </Typography>
          </Link>
          <LanguageSelector light />
          {/* Project-team login (SSO back-office) next to the language selector; icon only on phones. */}
          {compact ? (
            <Tooltip title={ui('nav.staffLogin')}>
              <IconButton component={RouterLink} to="/login" color="inherit" aria-label={ui('nav.staffLogin')} size="small">
                <LoginIcon />
              </IconButton>
            </Tooltip>
          ) : (
            <Button
              component={RouterLink}
              to="/login"
              color="inherit"
              variant="outlined"
              size="small"
              startIcon={<LoginIcon />}
              sx={{ borderColor: 'rgba(255,255,255,0.6)', whiteSpace: 'nowrap', '&:hover': { borderColor: '#fff', bgcolor: 'rgba(255,255,255,0.08)' } }}
            >
              {ui('nav.staffLogin')}
            </Button>
          )}
        </Toolbar>
      </AppBar>

      <Container component="main" maxWidth="sm" sx={{ flex: 1, py: { xs: 2, sm: 3 }, px: 2 }}>
        <Outlet />
      </Container>

      <Box component="footer" textAlign="center" px={2} py={2}>
        <Typography variant="caption" color="text.secondary" display="block">
          {ui('app.footer')}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          <Link component={RouterLink} to="/privacidad">{ui('nav.privacy')}</Link>
        </Typography>
      </Box>
    </Box>
  );
}
